import { request } from '@umijs/max';
import type {
  WorkAcknowledgement,
  WorkAcknowledgementResult,
  WorkListQuery,
  WorkListResponse,
  WorkSummary,
} from '@shared/work-items/contracts';

function unwrap<T>(response: T | { data: T }): T {
  return response && typeof response === 'object' && 'data' in response
    ? (response as { data: T }).data
    : (response as T);
}

export async function getWorkSummary(): Promise<WorkSummary> {
  return unwrap(await request<WorkSummary | { data: WorkSummary }>('/api/work-items/summary'));
}

export async function getWorkItems(query: WorkListQuery): Promise<WorkListResponse> {
  return unwrap(
    await request<WorkListResponse | { data: WorkListResponse }>('/api/work-items', {
      params: query,
    }),
  );
}

export async function acknowledgeWorkItems(
  items: WorkAcknowledgement[],
): Promise<WorkAcknowledgementResult> {
  return unwrap(
    await request<WorkAcknowledgementResult | { data: WorkAcknowledgementResult }>(
      '/api/work-items/acknowledgements',
      { method: 'POST', data: { items } },
    ),
  );
}
